'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ORDINAL_NUMBERS_ASC = '01234567890';
var ORDINAL_NUMBERS_DEC = '09876543210';

var hasOrdinalSignificance = function hasOrdinalSignificance(string) {
    return ORDINAL_NUMBERS_ASC.indexOf(string) !== -1 || ORDINAL_NUMBERS_DEC.indexOf(string) !== -1;
};

exports.default = function (passwordUnderTest) {
    var largestSequence = 0,
        currentSubString = null,
        i = 0,
        j = null;
    for (i; i < passwordUnderTest.length - 2; i++) {
        j = 3;
        for (j; j <= passwordUnderTest.length; j++) {
            currentSubString = passwordUnderTest.substr(i, j);
            if (hasOrdinalSignificance(currentSubString)) {
                if (currentSubString.length > largestSequence) {
                    largestSequence = currentSubString.length;
                }
            } else {
                break;
            }
        }
    }
    return largestSequence / passwordUnderTest.length;
};
//# sourceMappingURL=numeric-ordinal-penalty.js.map